import { anonymousClient, responseBody } from '../../../app/api/httpClient';

export const Calendar = {
    getCalendarEventInstancesAsync: () => anonymousClient.get(`Calendar`).then(responseBody),
    getCalendarEventInstanceByIdAsync: (id: string) => anonymousClient.get(`Calendar/${id}`).then(responseBody)
};
